const fileDownload = require('js-file-download');
import axios from 'axios';

export const handleDownloadFile = message => {
  const fileNameWithoutMarker = message.attributes.content.replace('azure510-', '');
  const isDev = typeof window !== 'undefined' && window.location?.hostname === 'localhost';

  axios
    .get(
      `${isDev ? 'http://localhost:3500' : ''}/api/azure-download?fileName=` +
        fileNameWithoutMarker,
      { responseType: 'blob' }
    )
    .then(resp => {
      fileDownload(resp.data, `${fileNameWithoutMarker}`);
    })
    .catch(error => {
      console.log(error);
    });
};
